export const CALL_UI_Z_INDEX = {
  incomingStack: 9999,
  headerWaitingDropdown: 10050
};

export const WAITING_CALLS_PULSE_CLASS = 'header-whatsapp-calls--alert';
export const WAITING_CALLS_DROPDOWN_OFFSET_PX = 8;
export const WAITING_CALLS_BADGE_MAX_DISPLAY = 9;
export const WS_CALL_CLIENT_LIST_SIDEBAR = 'WsCallClientListSidebarMC';
